import { PencilSimple, Warning } from '@phosphor-icons/react';
import { Alert, AlertDescription, AlertTitle } from '../../../components/ui/alert';
import { Button } from '../../../components/ui/button';
import type { ReviewIssuesMessage } from './reviewGridDraft';

const ICON_SIZE = 20;
// Three columns — icon tile, text, action — instead of Alert's icon + text.
const BANNER_CLASS = 'grid-cols-[auto_1fr_auto] items-center gap-x-3 bg-muted';
const ICON_TILE_CLASS =
  'row-span-2 flex size-10 items-center justify-center rounded-lg bg-background-warning-light-hover text-foreground-warning-default';
const EDIT_BUTTON_CLASS = 'col-start-3 row-span-2 row-start-1';

interface ReviewIssuesBannerProps {
  /** Null when nothing blocks the import: the banner is not shown. */
  issues: ReviewIssuesMessage | null;
  onEdit: () => void;
}

export function ReviewIssuesBanner({ issues, onEdit }: ReviewIssuesBannerProps) {
  if (issues === null) return null;
  // WHY role="status": the banner sits on screen the whole review and only its
  // counts change, so a polite update fits — Alert's default interrupts.
  return (
    <Alert role="status" className={BANNER_CLASS}>
      <span aria-hidden="true" className={ICON_TILE_CLASS}>
        <Warning size={ICON_SIZE} />
      </span>
      <AlertTitle className="text-body-md-medium text-foreground">{issues.title}</AlertTitle>
      <AlertDescription>{issues.detail}</AlertDescription>
      <Button type="button" variant="outline" size="sm" onClick={onEdit} className={EDIT_BUTTON_CLASS}>
        <PencilSimple aria-hidden="true" />
        Edit
      </Button>
    </Alert>
  );
}
